import React from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import { mobileDetect } from '../../shared/store';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { authLogout } from '../../shared/actions/authActions';

class MainMenu extends React.Component {
	isLogInActive(match, location) {
		if ((!match && location.pathname === '/login') || (match && match.isExact)) {
			return true;
		}

		return false;
	}

	handleLogout = async (e) => {
		e.preventDefault();
		await this.props.authLogout(this.props.user?.email);
		this.props.history.push('/login');
	}

	render() {
		const { isEducator=false, isAuthenticated=false } = this.props;

		if (isEducator) {
			return (
				<nav className='main-menu row no-gutters justify-content-end'>
					<NavLink to='/help' className='header-link'>
						Help
					</NavLink>
				</nav>
			);
		}

		return (
			<nav className='main-menu row no-gutters justify-content-end'>
				<a exact href={process.env.REACT_APP_MAIN_WP_URL || '/'} className='footer-link'>
					Home
				</a>
				<NavLink to='/contact' className='footer-link'>
					Contact
				</NavLink>
				<NavLink to='/download'>Download</NavLink>
				{/*<NavLink to='/api'>API</NavLink>*/}
				<NavLink to='/help' className='header-link'>
					Help
				</NavLink>
				<NavLink to='/subscription' className='footer-link'>
					Pricing
				</NavLink>
				{!mobileDetect.mobile() && !isAuthenticated && <NavLink to='/register'>Sign up</NavLink>}
				{!mobileDetect.mobile() && !isAuthenticated && (
					<NavLink to='/login' isActive={this.isLogInActive.bind(this)}>
						Log in
					</NavLink>
				)}
				{!mobileDetect.mobile() && isAuthenticated && (
					<a href="#" onClick={this.handleLogout}>
						Log out
					</a>
				)}
				<NavLink to='/help' className='footer-link'>
					Help
				</NavLink>
				<a
					href={
						process.env.REACT_APP_MAIN_WP_URL
							? `${process.env.REACT_APP_MAIN_WP_URL}/cookie-policy`
							: '/cookie-policy'
					}
					className='footer-link'>
					Cookie Policy
				</a>
				<a
					href={
						process.env.REACT_APP_MAIN_WP_URL
							? `${process.env.REACT_APP_MAIN_WP_URL}/privacy-policy`
							: '/privacy-policy'
					}
					className='footer-link'>
					Privacy Policy
				</a>
				<a
					href={
						process.env.REACT_APP_MAIN_WP_URL
							? `${process.env.REACT_APP_MAIN_WP_URL}/terms-and-conditions`
							: '/terms-and-conditions'
					}
					className='footer-link'>
					Terms and Conditions
				</a>
			</nav>
		);
	}
}

function mapStateToProps(state) {
	return {
		isAuthenticated: state.auth.isAuthenticated,
		user: state.auth.user
	};
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			authLogout
		},
		dispatch
	);
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(MainMenu));
